/* tslint:disable */
/* eslint-disable */
/* @relayHash 059bdc049696f094a7b66cf592115df5 */

import { ConcreteRequest } from "relay-runtime";
export type USER_STATUS = "ACTIVE" | "BANNED" | "PREMOD" | "SUSPENDED" | "WARNED" | "%future added value";
export type BanUserInput = {
    userID: string;
    clientMutationId: string;
    message: string;
    siteIDs?: Array<string> | null;
    rejectExistingComments?: boolean | null;
};
export type BanCommentUserMutationVariables = {
    input: BanUserInput;
};
export type BanCommentUserMutationResponse = {
    readonly banUser: {
        readonly user: {
            readonly id: string;
            readonly status: {
                readonly current: ReadonlyArray<USER_STATUS>;
            };
        };
        readonly clientMutationId: string;
    };
};
export type BanCommentUserMutation = {
    readonly response: BanCommentUserMutationResponse;
    readonly variables: BanCommentUserMutationVariables;
};



/*
mutation BanCommentUserMutation(
  $input: BanUserInput!
) {
  banUser(input: $input) {
    user {
      id
      status {
        current
      }
    }
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        } as any
    ], v1 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "BanUserPayload",
            "kind": "LinkedField",
            "name": "banUser",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "CoralUser",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "id",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "UserStatus",
                            "kind": "LinkedField",
                            "name": "status",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "current",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "clientMutationId",
                    "storageKey": null
                }
            ],
            "storageKey": null
        } as any
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "BanCommentUserMutation",
            "selections": (v1 /*: any*/),
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "BanCommentUserMutation",
            "selections": (v1 /*: any*/)
        },
        "params": {
            "id": "059bdc049696f094a7b66cf592115df5",
            "metadata": {},
            "name": "BanCommentUserMutation",
            "operationKind": "mutation",
            "text": null
        }
    } as any;
})();
(node as any).hash = '61f438e08038c98b632a4c8c8c9af646';
export default node;
